import React from 'react';
import { notification } from 'antd';

export const toaster = (
  type: 'success' | 'info' | 'error' | 'warning',
  message: string | React.ReactNode,
  duration?: any
) => {
  notification[type]({
    message: message ? message : '',
    duration: duration || 3,
  });
}
